// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file catpocs/v1/projects.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import { ProjectService } from "./projects_pb";

/**
 * CreateProject creates a new project
 *
 * @generated from rpc catpocs.v1.ProjectService.CreateProject
 */
export const createProject = ProjectService.method.createProject;

/**
 * GetProject retrieves a project by ID
 *
 * @generated from rpc catpocs.v1.ProjectService.GetProject
 */
export const getProject = ProjectService.method.getProject;

/**
 * ListProjects lists all accessible projects
 *
 * @generated from rpc catpocs.v1.ProjectService.ListProjects
 */
export const listProjects = ProjectService.method.listProjects;

/**
 * UpdateProject updates a project
 *
 * @generated from rpc catpocs.v1.ProjectService.UpdateProject
 */
export const updateProject = ProjectService.method.updateProject;

/**
 * DeleteProject deletes a project
 *
 * @generated from rpc catpocs.v1.ProjectService.DeleteProject
 */
export const deleteProject = ProjectService.method.deleteProject;

/**
 * AddProjectMember adds a member to a project
 *
 * @generated from rpc catpocs.v1.ProjectService.AddProjectMember
 */
export const addProjectMember = ProjectService.method.addProjectMember;

/**
 * RemoveProjectMember removes a member from a project
 *
 * @generated from rpc catpocs.v1.ProjectService.RemoveProjectMember
 */
export const removeProjectMember = ProjectService.method.removeProjectMember;

/**
 * ListProjectMembers lists members of a project with pagination and search
 *
 * @generated from rpc catpocs.v1.ProjectService.ListProjectMembers
 */
export const listProjectMembers = ProjectService.method.listProjectMembers;
